module.exports = __webpack_public_path__ + "static/media/joiner.cf83d132.png";